<script lang="ts">
    import {Cart} from "../../models/cart";
    import DispatchSection from "../checkout/dispatch/DispatchSection.svelte";
    import DispatchServiceSection from "../checkout/dispatch/DispatchServiceSection.svelte";

    export let cart: Cart;
</script>
{#if cart}
    <section>
        <div class="max-w-900px mx-auto">
            <DispatchSection title="Productos de envío a domicilio"
                             items={cart.partsWithDelivery}/>
            <DispatchSection title="Accesorios"
                             items={cart.accessories}/>
            <DispatchSection title="Servicios"
                             items={cart.services}/>
            <DispatchServiceSection title="Mantenimiento preventivo"
                                    items={cart.revisions}/>
            <DispatchServiceSection title="Planes"
                                    items={cart.plans}/>
        </div>
    </section>
{/if}